import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ScreenListHooks } from '../../Helper/ScreenHelper';
import { hasCreatePermission, hasEditPermission, hasdeletePermission, hasSharePermission } from '../../Utils/PermissionUtils';
import ShareModal from '../../Utils/ShareModal';
import service from '../../Services/service';
import DeleteModal from '../../Utils/DeleteModal';
import { toast } from 'react-toastify';

function ScreenListComponent() {

  const [lists, setLists] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('Name');
  const [sortDescending, setSortDescending] = useState(false);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalitems, setTotalitems] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [selectedScreenName, setSelectedScreenName] = useState('');
  const [selectedrowId, setSelectedRowId] = useState(0);

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const canEditScreen = hasEditPermission('Screen');
  const canDeleteScreen = hasdeletePermission('Screen');
  const canShareScreen = hasSharePermission('Screen');


  const [search, setSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchTerm(search);
      setPageNumber(1);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  async function getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize) {
    try {
      setLoading(true);
      const data = await ScreenListHooks(searchTerm, sortBy, sortDescending, pageNumber, pageSize);

      if (data) {
        setLists(data.items || []);
        setTotalPages(data.totalPages || 1);
        setTotalitems(data.totalItems || 0);
      }
    } catch (error) {
      toast.error("Failed to load screen list");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
  }, [searchTerm, sortBy, sortDescending, pageNumber, pageSize]);

  const handleSortChange = (event) => {
    const [field, order] = event.target.value.split('_');
    setSortBy(field);
    setSortDescending(order === 'desc');
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPageNumber(newPage);
    }
  };

  const handleDeleteClick = (id, name) => {
    setSelectedScreenName(name);
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await service.getdata("Screen/DeleteById?id=" + deleteId);
      if (response !== undefined) {
        toast.success('Screen Deleted successfully!');
        getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
      }
    } catch (error) {
      toast.error('Error deleting Screen.');
    } finally {
      setShowDeleteModal(false);
    }
  };

  return (
    <div className="container-fluid content-top-gap">

      {/* Breadcrumb */}
      <nav aria-label="breadcrumb" className="mb-4">
        <ol className="breadcrumb my-breadcrumb">
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active">Display's Management</li>
        </ol>
      </nav>

      <div className="card card_border mb-4">


        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center">

            <div>
              <h3 className="mb-1 font-weight-bold">
                Display's Management
              </h3>

              <small className="text-muted">
                Create and manage digital signage display's
              </small>
            </div>

          </div>
        </div>



        <div className="card-body">

          {/* Filters */}
          <div className="row mb-3">
            <div className="col-md-4">
              <input
                type="text"
                className="form-control"
                placeholder="Search by name..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div className="col-md-4 mt-2 mt-md-0">
              <select
                className="custom-select"
                onChange={handleSortChange}
                value={`${sortBy}_${sortDescending ? 'desc' : 'asc'}`}
              >
                <option value="Name_asc">Name (A-Z)</option>
                <option value="Name_desc">Name (Z-A)</option>
                <option value="CreatedAt_asc">Created At (Oldest)</option>
                <option value="CreatedAt_desc">Created At (Newest)</option>
                <option value="UpdatedAt_asc">Updated At (Oldest)</option>
                <option value="UpdatedAt_desc">Updated At (Newest)</option>
                <option value="CreatedBy_asc">Created By (A-Z)</option>
                <option value="CreatedBy_desc">Created By (Z-A)</option>
              </select>
            </div>

            <div className="col-md-4 mt-2 mt-md-0">
              <select
                className="custom-select"
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setPageNumber(1);
                }}
              >
                <option value={10}>Show 10</option>
                <option value={20}>Show 20</option>
                <option value={50}>Show 50</option>
                <option value={100}>Show 100</option>
              </select>
            </div>
          </div>

          {/* Table */}
          <table className="table table-striped table-bordered table-hover" style={{ fontSize: '14px' }}>
            <thead className="bg-light">
              <tr>
                <th>#</th>
                <th>Screen Name</th>
                <th>Current Layout</th>
                <th>Location</th>
                <th>Mac Address</th>
                <th>IP Address</th>
                <th>Device Status</th>
                <th>Is Active</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="text-center py-4">
                    <div className="spinner-border text-primary" />

                    <p className="mt-2 text-muted">
                      Loading screens...
                    </p>
                  </td>
                </tr>
              ) : lists.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center">No records found</td>
                </tr>
              ) : (
                lists.map((list, index) => (
                  <tr key={list.screenId}>
                    <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td>{list.screenName}</td>
                    <td>{list.currentLayout || "-"}</td>
                    <td>{list.location || "-"}</td>
                    <td>{list.macAddressId}</td>
                    <td>{list.ipaddress}</td>
                    <td><span className={`badge badge-${list.statusDevice === "True" ? "success" : "danger"}`}>
                      {list.statusDevice}
                    </span></td>
                    <td><span className={`badge badge-${list.isActive ? "success" : "secondary"}`}>
                      {list.isActive ? "Active" : "Inactive"}
                    </span></td>
                    <td>
                      <div className="d-flex gap-2">

                        {canEditScreen && (
                          <Link to={`/EditScreen/${list.screenId}`} className="btn btn-outline-info btn-sm">
                            Edit
                          </Link>
                        )}

                        {canDeleteScreen && (
                          <Link
                            to="#"
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleDeleteClick(list.screenId, list.screenName)}
                            disabled={loading}
                          >
                            Delete
                          </Link>
                        )}

                        {canShareScreen && (
                          <Link
                            to="#"
                            className="btn btn-outline-success btn-sm"
                            onClick={() => {
                              setSelectedScreenName(list.screenName);
                              setSelectedRowId(list.screenId);
                              setShowModal(true);
                            }}
                            disabled={loading}
                          >
                            Share
                          </Link>
                        )}

                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center flex-wrap mt-4">

            <div className="text-muted">
              Showing{" "}
              <strong>
                {(pageNumber - 1) * pageSize + 1}
              </strong>
              {" - "}
              <strong>
                {Math.min(pageNumber * pageSize, totalitems)}
              </strong>
              {" of "}
              <strong>{totalitems}</strong>
              {" Display's"}
            </div>

            <nav>
              <ul className="pagination pagination-sm mb-0">

                <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setPageNumber(pageNumber - 1)}
                  >
                    <i className="fa fa-angle-left"></i>
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${pageNumber === i + 1 ? "active" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setPageNumber(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}

                <li className={`page-item ${pageNumber === totalPages ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setPageNumber(pageNumber + 1)}
                  >
                    <i className="fa fa-angle-right"></i>
                  </button>
                </li>

              </ul>
            </nav>

          </div>

        </div>
      </div>

      {/* Modals */}
      <ShareModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        screenName={selectedScreenName}
        moduleId={2}
        rowId={selectedrowId}
      />

      <DeleteModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={handleConfirmDelete}
        message="Are you sure you want to delete this display?"
        itemName={selectedScreenName + " Display"}
      />

    </div>
  );
}

export default ScreenListComponent;
